export function normalizeEmptyNumericFields(item: any, numericKeys: string[]): any {
  if (!item || numericKeys.length === 0) {
    return item;
  }

  let changed = false;
  const normalized = { ...item };

  for (const key of numericKeys) {
    if (normalized[key] === '') {
      normalized[key] = null;
      changed = true;
    }
  }

  return changed ? normalized : item;
}
